export default __webpack_public_path__ + "locales/ar-SA/Ldap.json?hash=6a07f1cd6bd010c1e0c5922f6fe8bd65";